import { gql } from "apollo-boost";

export const GET_USER_CONFIRM = gql`
query Userconfirms($limit: Int, $skip: Int, $orderBy: OrderByInput, $where: UserConfirmWhereInput) {
  userconfirms(limit: $limit, skip: $skip, orderBy: $orderBy, where: $where) {
    total
    data {
      createdAt
      detail
      gender
      id
      isDeleted
      lastname
      name
      phone
      userCode
      updatedAt
      userType {
        id
        name
        isOpen
      }
      address {
        village
        province
        district
      }
      totalPoint
      currentPoint
    }
  }
}
`
export const GET_USER_CONFIRM_ONE = gql`
query UserconfirmV2($where: UserConfirmWhereInputOne!) {
  userconfirmV2(where: $where) {
    id
    name
    lastname
    phone
    totalPoint
    currentPoint
    address {
      province
      district
      village
    }
    gender
    detail
    userType {
      name
      id
      isOpen
    }
    isDeleted
    createdAt
    updatedAt
  }
}
`